export default {
  general: {
    showSoldNeighbourhoods: false,
    showSoldPrice: false,
    appResetTimeoutMinutes: 15,
  },
  filter: {
    enabled: false,
  },
};
